import api from './api';
import type { PagedResult } from '../types';
import type {
  CrmCambiarEtapa,
  CrmCerrarGanada,
  CrmCerrarPerdida,
  CrmKanban,
  CrmOportunidad,
  CrmOportunidadCreate,
  CrmOportunidadListItem,
  CrmOportunidadSearch,
  CrmOportunidadUpdate,
} from '../types/crm';

const crmOportunidadService = {
  getAll: async (params: CrmOportunidadSearch = {}): Promise<PagedResult<CrmOportunidadListItem>> => {
    const response = await api.get<PagedResult<CrmOportunidadListItem>>('/api/CrmOportunidades', {
      params: {
        pageNumber: 1,
        pageSize: 50,
        ...params,
      },
    });
    return response.data;
  },

  getById: async (id: number): Promise<CrmOportunidad> => {
    const response = await api.get<CrmOportunidad>(`/api/CrmOportunidades/${id}`);
    return response.data;
  },

  getKanban: async (params: {
    pipelineId?: number;
    nroVendedor?: number;
    searchTerm?: string;
    diasEstancado?: number;
  } = {}): Promise<CrmKanban> => {
    const response = await api.get<CrmKanban>('/api/CrmOportunidades/kanban', { params });
    return response.data;
  },

  create: async (dto: CrmOportunidadCreate): Promise<CrmOportunidad> => {
    const response = await api.post<CrmOportunidad>('/api/CrmOportunidades', dto);
    return response.data;
  },

  update: async (id: number, dto: CrmOportunidadUpdate): Promise<CrmOportunidad> => {
    const response = await api.put<CrmOportunidad>(`/api/CrmOportunidades/${id}`, dto);
    return response.data;
  },

  cambiarEtapa: async (id: number, dto: CrmCambiarEtapa): Promise<CrmOportunidad> => {
    const response = await api.post<CrmOportunidad>(`/api/CrmOportunidades/${id}/cambiar-etapa`, dto);
    return response.data;
  },

  cerrarGanada: async (id: number, dto: CrmCerrarGanada = {}): Promise<CrmOportunidad> => {
    const response = await api.post<CrmOportunidad>(`/api/CrmOportunidades/${id}/cerrar-ganada`, dto);
    return response.data;
  },

  cerrarPerdida: async (id: number, dto: CrmCerrarPerdida): Promise<CrmOportunidad> => {
    const response = await api.post<CrmOportunidad>(`/api/CrmOportunidades/${id}/cerrar-perdida`, dto);
    return response.data;
  },
};

export default crmOportunidadService;
